import type { QueryParams } from 'shared/types';


type Position = {
	top: number,
	left: number,
	height: number,
	width: number
}

type Size = {
	width: number,
	height: number,
}
export type { Size }

type ObjectFitSize = {
	availableWidth: number,
	availableHeight: number,
	objectWidth: number,
	objectHeight: number,
}

export function elementPosition(el: HTMLElement): Position {
	let rect = el.getBoundingClientRect();
	let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
	let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	let position = {
		top: rect.top + scrollTop,
		left: rect.left + scrollLeft,
		height: el.offsetWidth,
		width: el.offsetWidth
	};

	return position;
}
export function isDescendant(parent: HTMLElement, child: HTMLElement): boolean {
	let node = child.parentNode;
	while (node != null) {
		if (node === parent) {
			return true;
		}
		node = node.parentNode;
	}
	return false;
}
export function isMobile(): boolean {
	let check = false;
	//eslint-disable-next-line
	(function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
	return check;
}
export function isPhone(): boolean {
	let check = false;
	//eslint-disable-next-line
	(function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
	return check;
}

export function isiOS(os: string): boolean {
	return /ios/.test(os.toLowerCase());
}

export function isAndroid(os: string): boolean {
	return /android/.test(os.toLowerCase());
}

let timer: number;
export function debounce(callback: Function, delay: number): void {
	if (timer) clearTimeout(timer);

	timer = setTimeout(callback, delay);
}

export function calculateCoverModeLoss(data: ObjectFitSize): number {
	/**
	 * Useful to calculate loss on "cover" mode view for videos & images
	 */
	let widthZoomCoefficient = data.availableWidth / data.objectWidth;
	let heightZoomCoefficient = data.availableHeight / data.objectHeight;

	let coverModeLoss = 0;
	if (widthZoomCoefficient >= heightZoomCoefficient) {
		coverModeLoss = (1 - heightZoomCoefficient / widthZoomCoefficient) * 100;
	} else {
		coverModeLoss = (1 - widthZoomCoefficient / heightZoomCoefficient) * 100;
	}

	/**
	 * Why this formula: coverModeLoss = 1 - widthZoomCoefficient/heightZoomCoefficient; ?
	 * This is a simplyfied formula of calculations and other formulas.
	 */

	return coverModeLoss;
}

export function calculateFitSize(data: ObjectFitSize): Size {
	let widthZoomCoefficient = data.availableWidth / data.objectWidth;
	let heightZoomCoefficient = data.availableHeight / data.objectHeight;

	let coefficient = widthZoomCoefficient;
	if (widthZoomCoefficient >= heightZoomCoefficient) {
		coefficient = heightZoomCoefficient;
	}

	let fitSize = {
		width: coefficient * data.objectWidth,
		height: coefficient * data.objectHeight,
	}

	return fitSize;
}

export function calculateElementsFitSize(element?: HTMLVideoElement, containerElement?: HTMLElement): Size | null {
	if (!element || !containerElement) return null;

	let maxSize = containerElement.clientWidth
	if (containerElement.clientWidth < containerElement.clientHeight) {
		maxSize = containerElement.clientHeight
	}

	const calculateSize = {
		availableWidth: maxSize,
		availableHeight: maxSize,
		objectWidth: element.videoWidth,
		objectHeight: element.videoHeight,
	}
	return calculateFitSize(calculateSize);
}

export function isObjectPropertyUpdated(prev: any, current: any, ...keys: string[]): boolean {
	let prevValue = prev;
	let currentValue = current;

	keys.forEach((key) => {
		prevValue = prevValue[key];
		currentValue = currentValue[key];
	})

	return JSON.stringify(prevValue) !== JSON.stringify(currentValue);
}

export function adaptVersionsToSemver(version: string): string | null {
	if (!version) return null;

	let newVersion = version.split(".");
	if (newVersion.length < 3) newVersion.push("0");
	else if (newVersion.length > 3) newVersion = newVersion.slice(0, 3);

	return newVersion.join(".");
}

export function setCookie(key: string, value: string): void {
	document.cookie = `${key}=${value}`;
}

export function getCookie(key: string): string | null {
	let cookie = document.cookie.split(";").find((keyPair) => {
		let kp = keyPair.split("=");
		if (kp[0] === key) return true;
		return false;
	});

	return cookie ? cookie.split("=")[1] : null;
}

export function cleanQueryParams(params: any): QueryParams {
	let cleanParams: QueryParams = {};
	Object.keys(params).forEach((filterKey) => {
		if (params[filterKey] !== "" && params[filterKey] !== null && params[filterKey] !== undefined) {
			cleanParams[filterKey] = params[filterKey];
		}
	});

	return cleanParams;
}

export function detectWebcam(callback: (hasWebcam: boolean) => void) {
	let md = navigator.mediaDevices;
	if (!md || !md.enumerateDevices) return callback(true);
	md.enumerateDevices().then(devices => {
		callback(devices.some(device => 'videoinput' === device.kind));
	})
}

export type DetectedDevices = {
	hasWebcam: boolean,
	hasMicrophone: boolean,
}
export function detectDevices(callback: (detectedDevices: DetectedDevices) => void) {
	let md = navigator.mediaDevices;
	if (!md || !md.enumerateDevices) return callback({
		hasWebcam: true,
		hasMicrophone: true,
	});
	md.enumerateDevices().then(devices => {
		callback({
			hasWebcam: devices.some(device => 'videoinput' === device.kind),
			hasMicrophone: devices.some(device => 'audioinput' === device.kind),
		});
	});
}
